export const getNaverDirectionUrl = (externalId) => {
    if (!externalId)
        return "";
    return `https://m.place.naver.com/share?id=${externalId}&tabsPath=%2Fhome&appMode=detail`;
};
//# sourceMappingURL=getNaverDirectionUrl.js.map